export default class IndicatorDataSource {
  constructor(dataSource = {}) {
    this.key = dataSource.key ? dataSource.key : ""
    this.name = dataSource.name ? dataSource.name : ""
    this.variables = dataSource.variables ? 
    dataSource.type != 0 || typeof dataSource.variables[0] == "object" ? dataSource.variables 
    : dataSource.variables.map(v => JSON.parse(v)) : ""
    this.type = dataSource.type ? dataSource.type : 0
    this.used = dataSource.used ? dataSource.used : false
    this.note = dataSource.note ? dataSource.note : ""
  }
}